<div class="card col-lg-12 col-md-12 col-sm-12">
  <div class="card-header">
    <h4 class="card-title" id="basic-layout-form">{{ title }}</h4>
    <p class="mb-0">{{ description }}</p>
  </div>
  <div class="card-body">
    <div class="px-3">
      <form [formGroup]="dynamicForm" (ngSubmit)="onSubmit()">
        <div class="form-body">
          <h4 class="form-section">
            <i class="ft-cpu"></i> {{ details }}
          </h4>

          <div formArrayName="formSettings">
            <div *ngFor="let formSetting of formSettings.controls; index as i">
              <div [ngSwitch]="formSetting.value.settingTypeCode">

                <!-- Text field -->
                <div *ngSwitchCase="settingType.text">
                  <div class="form-group" [formGroupName]="i">
                    <label>{{ formSetting.value.displayName }}</label>
                    <input type="text" class="form-control" formControlName="value"
                           [placeholder]="formSetting.value.displayName">
                  </div>
                </div>

                <!-- Password field -->
                <div *ngSwitchCase="settingType.password">
                  <div class="form-group" [formGroupName]="i">
                    <label>{{ formSetting.value.displayName }}</label>
                    <div class="input-group">
                      <input [type]="formSetting.value.passwordType" class="form-control" formControlName="value"
                             [placeholder]="formSetting.value.displayName">
                      <div class="input-group-append">
                        <span class="input-group-text">
                          <a data-original-title="" title="toggle"
                             (click)="togglePassword(i, formSetting.value.passwordType)">
                            <i [ngClass]="passwordIconClass"></i>
                          </a>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- ApiKey field -->
                <div *ngSwitchCase="settingType.apiKey">
                  <div class="form-group" [formGroupName]="i">
                    <label>{{ formSetting.value.displayName }}</label>
                    <div class="input-group">
                      <input type="password" class="form-control" formControlName="value"
                             [placeholder]="formSetting.value.displayName">
                      <button class="btn btn-raised btn-raised btn-warning ml-1" type="button" title="Generate Api Key"
                              (click)="generateApiKey(i)">
                        <i class="icon-key"></i></button>
                      <button class="btn btn-primary btn-raised ml-1" type="button" title="Copy Api Key"
                              (click)="copyApiKey(formSetting.value.value)">
                        <i class="ft-copy"></i></button>
                    </div>
                  </div>
                </div>

                <!-- Number field -->
                <div *ngSwitchCase="settingType.number">
                  <div class="form-group" [formGroupName]="i">
                    <label>{{ formSetting.value.displayName }}</label>
                    <input type="number" class="form-control" formControlName="value"
                           [placeholder]="formSetting.value.displayName">
                  </div>
                </div>

                <!-- Boolean field -->
                <div *ngSwitchCase="settingType.boolean">
                  <div class="custom-control custom-checkbox mb-2" [formGroupName]="i">
                    <input type="checkbox" class="custom-control-input" formControlName="value"
                           [placeholder]="formSetting.value.displayName">
                    <label class="custom-control-label">{{ formSetting.value.displayName }}</label>
                  </div>
                </div>

                <!-- Option (radio) field TODO: implement! Multiple options - one setting to save -->
                <div *ngSwitchCase="settingType.option">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn btn-raised btn-raised btn-warning mr-1" type="button" (click)="resetForm()">
            <i class="ft-x"></i> {{ 'buttons.resetText' | translate }}
          </button>
          <button [disabled]="!dynamicForm.valid" class="btn btn-raised btn-raised btn-primary mr-1" type="submit">
            <i class="ft-check-square"></i> {{ 'buttons.saveText' | translate }}
          </button>
          <button [hidden]="!canBeTested" [disabled]="!dynamicForm.valid"
                  class="btn btn-raised btn-raised btn-primary mr-1" type="button" (click)="test()">
            <i class="fa fa-check"></i> {{ 'buttons.testSettingsText' | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
